export const getMappedRUEUList = (builder) => ({
    getMappedRUEUList: builder.mutation({
      query: ({ pageNumber, limit, search }) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
  
        return {
          url: '/list_of_enteprise_user_acc_reporting_user',
          method: 'GET',
          params: { pageNumber, limit, search },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
        };
      },
    }),
  });
  